// The backend answers 403 on bookmark/follow calls when the viewer is not Pro
// (e.g. a downgrade the page has not noticed yet).
export const PRO_REQUIRED_EVENT = 'tt:pro-required';

export const isProRequired = (response) => response.status === 403;

// Tells the app to re-read the user's tier (AuthContext listens for this).
export const notifyProRequired = () => {
	if (typeof window !== 'undefined') {
		window.dispatchEvent(new Event(PRO_REQUIRED_EVENT));
	}
};

// Error thrown by write calls so callers can tell "not Pro" from other failures.
export const proRequiredError = () => {
	notifyProRequired();
	const error = new Error('PRO required');
	error.code = 'PRO_REQUIRED';
	return error;
};
